// index.js or main file
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import Game from './pages/game/game';
import Intro from './pages/intro/intro';
import Thankyou from './pages/thankyou/thankyou';
import Admin from './admin/admin';
import SuperAdminLogin from './admin/SuperAdminLogin';
import AdminThemes from './admin/AdminThemes';
import AdminRules from './admin/AdminRules';
import AdminCandyIcons from './admin/AdminCandyIcons';
import DDDUI from './pages/dddUI/ddd';

function usePageBackground() {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;

    body.classList.remove('common-bg');

    switch (location.pathname) {
      case '/':
      case '/login':
        body.classList.add('common-bg');
        body.classList.add('common-bg1');

        break;
      case '/game':
        body.classList.remove('rules-bg');
        body.classList.add('common-bg');
        break;
     
      case '/intro':
        body.classList.add("common-bg", "rules-bg");
        break;
      case '/thankyou':
        body.classList.add('common-bg');
                body.classList.add('common-bg1');
        break;
   
        default:
        // admin pages keep a plain white background (no themed bg)
        if (location.pathname.startsWith('/admin')) body.style.backgroundImage = '';
        break;
    }
  }, [location]); 
}


function App() {
  usePageBackground();
  const navigate = useNavigate();
  const location = useLocation();

  const [fromMobileApp, setFromMobileApp] = useState(() => {
    try {
      return sessionStorage.getItem("fromMobileApp") === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mobile = params.get("fromMobileApp");
    if (mobile === "true" || mobile === "1") {
      sessionStorage.setItem("fromMobileApp", "true");
      setFromMobileApp(true);
    }
  }, [location.pathname, location.search]);
   
     // Get initial image from sessionStorage or env variable
     const getInitialImage = () => {
       return sessionStorage.getItem("orgData") || process.env.REACT_APP_EM_LOGO;
     };
   
     // State for header config
     const [headerConfig, setHeaderConfig] = useState({
       imageUrl: getInitialImage(),
       backButtonRedirect: "/", // Default back button
     });
   
     // Update both image and back button together (ONLY from Login)
     const updateHeader = ({ imageUrl, backButtonRedirect }) => {
       setHeaderConfig((prev) => ({
         imageUrl: imageUrl || prev.imageUrl, // Only update if provided
         backButtonRedirect: backButtonRedirect || prev.backButtonRedirect, // Only update if provided
       }));
   
       // Store image in sessionStorage if provided
       if (imageUrl) sessionStorage.setItem("orgData", imageUrl);
     };
   
   
    const handleBack = () => {
       const { backButtonRedirect } = headerConfig;
   
       if (backButtonRedirect.length > 20) {
         // Open in new tab (External Link)
         window.location.href = backButtonRedirect;
       } else {
         // Internal Navigation
         navigate(backButtonRedirect);
       }
     };

    const handleLogoClick = () => {
      if (fromMobileApp) {
        window.GameStatus?.postMessage?.("navigate_back");
        return;
      }
      window.location.href = process.env.REACT_APP_BASE_URL;
    };
   
  

  return (
<DDDUI
  imageUrl={headerConfig.imageUrl}
  onBack={handleBack}
  onLogoClick={handleLogoClick}
  hideBackButton={fromMobileApp}
  hideHeader={location.pathname.startsWith('/admin')}
>
      <Routes>
        <Route path="/" element={<Login updateHeader={updateHeader}/>} />
        <Route path="/game" element={<Game updateHeader={updateHeader}/>} />
        <Route path="/login" element={<Login updateHeader={updateHeader} />} />
        <Route path="/intro" element={<Intro updateHeader={updateHeader}/>} />
        <Route path="/thankyou" element={<Thankyou updateHeader={updateHeader}/>} />
         <Route path="/admin" element={<Admin/>} />
         <Route path="/admin/superadmin" element={<SuperAdminLogin/>} />
         <Route path="/admin/themes" element={<AdminThemes/>} />
         <Route path="/admin/rules/:themeName" element={<AdminRules/>} />
         <Route path="/admin/candy-icons/:themeName" element={<AdminCandyIcons/>} />
      </Routes>
      </DDDUI>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
